import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatTime, getDirection, vehicleTypeMap } from 'features/dashboard/utils/notification-utils'
import { Tag } from 'primereact/tag'
import MercosulPlate from 'shared/mercosul-plate/mercosul-license-plate'



interface CameraEvent {
  cameraId: string
  eventType: string
  timestamp: string
  imageBase64: string
  metadata: Record<string, string>
}

interface AnprEventCardProps {
  event: CameraEvent
  index: number
  displayMode: 'detailed' | 'simple'
  onImageClick: (event: CameraEvent) => void
}

const getVehicleType = (vehicleType: string) => {
  const type = vehicleTypeMap[vehicleType as keyof typeof vehicleTypeMap]
  if (!type) return null

  return (
    <Tag
      severity='info'
      value={
        <>
          <FontAwesomeIcon
            icon={type.icon}
            size='sm'
            className='mr-1'
          />
          {type.label}
        </>
      }
    />
  )
}

export const AnprEventCard = ({
  event,
  index,
  displayMode,
  onImageClick,
}: AnprEventCardProps) => {
  if (displayMode === 'simple') {
    return (
      <div
        key={`today-${index}`}
        className='notification-grid-item simple-item'
        onClick={() => onImageClick(event)}
      >
        <div className='simple-notification-content'>
          <div className='simple-expand-icon'>
            <i className='pi pi-search-plus'></i>
          </div>
          <div className=''>
            <div className='license-plate-section'>
              <MercosulPlate
                licensePlate={event.metadata?.LicensePlate}
                size='S'
              />
            </div>
            <div className='simple-metadata'>
              {formatTime(event.timestamp)}
              <div className='camera-name'>
                <i className='pi pi-video'></i>
                <span>{event.cameraId}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      key={`anpr-${index}`}
      className='notification-grid-item'
      onClick={() => onImageClick(event)}
    >
      <div className='notification-image-container'>
        {event.imageBase64 ? (
          <img
            src={event.imageBase64}
            alt={`Veículo ${event.metadata?.LicensePlate}`}
            className='notification-image'
          />
        ) : (
          <div className='camera-placeholder'>
            <i className='pi pi-video'></i>
          </div>
        )}

        <div className='notification-info'>
          <div className='info-header'>
            <div className='camera-info'>
              <i className='pi pi-video'></i>
              <span>{event.cameraId}</span>
            </div>
            <div className='expand-icon'>
              <i className='pi pi-search-plus'></i>
            </div>
          </div>

          <div className='info-content'>
            <div className='license-plate-section'>
              {event.metadata.VehicleType !== 'people' && (
                <MercosulPlate
                  licensePlate={event.metadata?.LicensePlate}
                  size='S'
                />
              )}
            </div>

            <div className='metadata-section'>
              <div className='metadata-row'>
                {formatTime(event.timestamp)}
              </div>
              <div className='metadata-row'>
                {event.metadata?.VehicleType &&
                  getVehicleType(event.metadata.VehicleType)}
                {event.metadata?.Direction &&
                  getDirection(event.metadata.Direction)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
